 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import A0_BEARS from '@/components/00_Bears'
 import A1_BEARS from '@/components/01_Bears'
 import A2_BEARS_ENDAGERED_SPECIES_ACT from '@/components/02_Bears_Endagered_Species_Act'
 import A3_BEARS_HIBERNATION from '@/components/03_Bears_Hibernation'
 import A4_BEARS_RASPBERRY from '@/components/04_Bears_Raspberry'
 import A5_BEARS_BEAR_791 from '@/components/05_Bears_Bear_791'
 import A6_BEARS_SNOW from '@/components/06_Bears_Snow'
 import A7_BEARS_SNAGGLETOOTH from '@/components/07_Bears_Snaggletooth'
 import A8_BEARS_OBSIDIAN from '@/components/08_Bears_Obsidian'
 import A9_BEARS_BACK from '@/components/09_Bears_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/00_Bears",
 			"name" : "00_Bears",
 			"component" : A0_BEARS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js